<template>
  <form @submit.prevent="doAction" class="message-send" ref="message-send">
    <label class="message-send__upload" for="file-uploader">
      <input
        type="file"
        id="file-uploader"
        style="display:none"
        @change="uploadImage"
        ref="file-uploader"
      />
      <img src="@/assets/images/attach.svg" width="30px" alt="attach" />
    </label>

    <div class="message-send__input">
      <input
        type="text"
        :placeholder="$t('forms.newMessage')"
        v-model="message"
        @blur="onBlur"
      />
    </div>

    <div class="message-send__btn">
      <button
        :disabled="!isValid"
        :class="{
          btn_disabled: !isValid,
        }"
      >
        <img src="@/assets/images/send.svg" alt="send" />
      </button>
    </div>

    <div class="message-send__images" v-if="images.length > 0">
      <div
        v-for="item in images"
        class="message-send__image-box"
        :key="item.id"
      >
        <img :src="item.url" alt="" class="message-send__image" />
        <img
          @click="deleteImage(item.url)"
          class="message-send__image_delete"
          src="@/assets/images/deletePhoto.svg"
          alt=""
        />
      </div>
    </div>
  </form>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  name: "message-send",
  computed: {
    ...mapGetters({
      client: "client/client",
    }),
    placeholder() {
      return this.images.length > 0 ? "" : "Message";
    },
    isValid() {
      if (this.images.length > 0) {
        return true;
      }

      if (this.message == "" || this.message == null) {
        return false;
      }

      return true;
    },
  },
  data() {
    return {
      message: "",
      images: [],
      index: 0,
    };
  },
  methods: {
    ...mapActions({
      send: "chat/send",
      sendImages: "chat/sendImages",
    }),
    async doAction(e) {
      if (!this.isValid) {
        return;
      }

      if (this.images.length > 0) {
        await this.sendImages({
          images: this.images,
          client: this.client,
        });
        this.clear();
        this.$emit("imageUploaded");
        return;
      }

      this.send({
        message: this.message,
        client: this.client,
      });
      this.$log("chat_messageSent");
      this.clear();
    },
    clear() {
      this.message = "";
      this.images = [];
      this.index = 0;
    },
    uploadImage({ target }) {
      const fileReader = new FileReader();

      const files = Object.values(target.files);

      files.forEach((file) => {
        fileReader.readAsDataURL(file);

        fileReader.addEventListener("load", () => {
          const url = fileReader.result;
          this.images.push({
            id: ++this.index,
            url,
            media: file,
          });
        });
      });
    },
    deleteImage(url) {
      this.images = this.images.filter((image) => {
        return image.url != url;
      });

      this.$refs["message-send"].reset();
    },
    onBlur() {
      window.scrollTo({
        top: 0,
      });
    },
  },
  beforeDestroy() {
    this.clear();
  },
};
</script>

<style lang="scss" scoped>
.message-send {
  background-color: #fff;
  box-shadow: 0px -0.5px 0px rgba(0, 0, 0, 0.1);
  border-radius: 0px 0px 4px 4px;
  width: 100%;
  height: 91px;
  display: flex;
  position: relative;

  &__upload {
    display: flex;
    align-items: center;
    padding: 0 16px;
    cursor: pointer;
  }

  &__input {
    width: 100%;

    input {
      width: 100%;
      height: 94%;
      padding: 0 0 0 10px;
      margin: 0;
      outline: none;
      border-color: transparent;
    }
  }

  &__btn {
    display: flex;
    align-items: center;
    padding-right: 21px;
    position: relative;
    z-index: 3;

    button {
      cursor: pointer;
      outline: none;
      padding: 0;
      border: none;
      background-color: transparent;
    }
  }

  &__images {
    position: absolute;
    left: 60px;
    top: 0;
    bottom: 0;
    margin: 0 auto;
    background-color: #fff;
    z-index: 2;
    display: flex;
    align-items: center;
  }

  &__image-box {
    border: 2px solid #000;
    border-radius: 10px;
    margin-right: 15px;
    position: relative;
  }

  &__image {
    width: 50px;
    height: 50px;
    object-fit: contain;

    &_delete {
      position: absolute;
      right: -5px;
      top: -5px;
      color: #000;
    }
  }
}
</style>
